<template>
	<div class="zfyz">
        <main>
            <div class="list">
                <h2>猪粪运载</h2>
                <h3>客户：浙江禾壮肥料有限公司</h3>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="zhuchang"
                    label="猪场"
                    placeholder="点击选择"
                    @click="showPicker2 = true"
                />

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-field
                    v-model="chepai"
                    center
                    label="车牌"
                    placeholder="请输入车牌"
                >
                    <template #button>
                        <van-button size="mini" type="danger" @click="searchCar()">搜索</van-button>
                    </template>
                </van-field>

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-picker 
                        show-toolbar 
                        :columns="columns3" 
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>

                <van-field v-model="tell" label="电话" type="number"/>
                <van-field v-model="name" label="姓名" />
                <van-field @blur="handleInput1" v-model="flow1" type="number"  label="装前" />
                <van-field @blur="handleInput2" v-model="flow2" type="number"  label="装后" />
                <van-field v-model="now1" label="当期装载(吨)" readonly/>
                <van-field v-model="money" label="过磅费(元)" />
                
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="message"
                    label="备注(客户)"
                    placeholder="点击选择"
                    @click="showPicker4 = true"
                />

                <van-popup v-model:show="showPicker4" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns4"
                        @confirm="onConfirm4"
                        @cancel="showPicker4 = false"
                    />
                </van-popup>
               
                <h4> 业务时间（对应装满后照片上面的水印为准）</h4>
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="业务时间"
                    placeholder="点击选择"
                    @click="showPicker = true"
                />

                <van-popup v-model:show="showPicker" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>

                <h4>整车(显示车牌)、装前、装后</h4>
                <van-uploader  v-model="fileList" multiple :max-count="3"  :before-read="beforeRead"/>
                <br><br>
                <br><br>
                <van-button type="danger" style="width:100%" @click="sub()">提交</van-button>

            </div>
        </main>
    </div>
</template>

<script>
    import { url,carList } from '../router/api';
    import options from "../config/option.js"

	export default{
		data(){
			return{
                time:'',
                maxDate: new Date(2030, 10, 1),
                currentDate: new Date(),
                showPicker:false,

                zhuchang:'',
                showPicker2:false,
                columns2:[],

                chepai:'',
                columns3:[],
                showPicker3:false,

                tell:'',
                name:'',
                flow1:'',
                flow2:'',
                now1:'',
                money:'',
                message:'',

                fileList: [],
                loading:'',

                columns4:[],
                showPicker4:false,
            }
        },

        watch: {
            flow1(val) {
                this.now1 = this.flow2 - this.flow1;
                this.now1 = this.now1.toFixed('2')
            },
            flow2(val) {
                this.now1 = this.flow2 - this.flow1;
                this.now1 = this.now1.toFixed('2')
            },
        },

        mounted() {
            const elementToRemove = '全部';
            this.columns2 = options.zhuchang.filter(item => item !== elementToRemove);
            this.getKehu()
        },

		methods: {
            getKehu() {
                this.axios.get(url+'xs/kehuList', {
                    params:{
                        id:'',
                    }
                }).then(res=> {
                    if(res.data.code==1) {
                        res.data.data.map(item=>{
                            item.text = item.name
                            delete (item.name)
                        })
                        this.columns4 = res.data.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            onConfirm(value) {
                this.time = this.formatDate(value)
                this.showPicker = false;
            },

            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },

            onConfirm2(value) {
                this.zhuchang = value;
                this.showPicker2 = false;
            },

            onConfirm3(value) {
                this.chepai = value.text
                this.showPicker3 = false;
            },

            onConfirm4(value) {
                this.message = value.text
                this.showPicker4 = false;
            },

            searchCar() {
                carList({
                    id:'',
                    chepai:this.chepai ? this.chepai: '',
                    xz_status:'',
                    gongsi: '' ,
                }).then(res=> {
                    if(res.code==1) {
                        res.data.map(item=>{
                            item.text = item.chepai
                            delete (item.chepai)
                        })
                        this.columns3 = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
                this.showPicker3 = true
            },
            handleInput1(e) {
                this.flow1 = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            },
            handleInput2(e) {
                this.flow2 = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            },
            beforeRead(file){
               return this.$compress(file)
            },

            sub() {
                if(this.zhuchang=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入猪场',
                    }).then(() => {
                        return;
                    });
                } else if(this.chepai=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入车牌',
                    }).then(() => {
                        return;
                    });
                } else if(this.tell=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入电话',
                    }).then(() => {
                        return;
                    });
                } else if(this.name=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入姓名',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入装前',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入装后',
                    }).then(() => {
                        return;
                    });
                } else if(this.now1 < 1 ) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '装载量不能为负',
                    }).then(() => {
                        return;
                    });
                } else if(this.money=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入过磅费',
                    }).then(() => {
                        return;
                    });
                } else if(this.message=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入备注',
                    }).then(() => {
                        return;
                    });
                } else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入业务时间',
                    }).then(() => {
                        return;
                    });
                }else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否确定提交',
                    }).then(() => {
                        this.sure()
                    }).catch(() => {});
                }
            },

            sure() {
                 if(this.fileList.length<3) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传三张照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                    this.axios.post(url+'xs/upload_zfyz',(formData),{
                        headers: {  'Content-Type': 'multipart/form-data;' }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.sure2(res.data.data)
                        }  else {
                            this.loading.close();
                        }
                    }).catch(err=> {
                        this.loading.close();
                        console.log(err);
                    });
                }
            },

            sure2(photo) {
                this.axios.get(url+'xs/zfyzAdd', {
                    params:{
                        zhuchang: this.zhuchang,
                        chepai: this.chepai,
                        tell: this.tell,
                        name: this.name,
                        flow1: this.flow1,
                        flow2: this.flow2,
                        now1: this.now1,
                        money: this.money,
                        time: this.time,
                        message:this.message,
                        url:photo.toString()
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.fileList = []
                            this.zhuchang = ''
                            this.chepai = ''
                            this.tell = ''
                            this.name = ''          
                            this.flow1 = ''
                            this.flow2 = ''
                            this.now1 = ''
                            this.money = ''
                            this.time = ''
                            this.message = ''
                        })
                    } else {
                            this.loading.close();
                        }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            }
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .zfyz main {
        font-size: 14px;
        padding: 40px 16px 60% 16px;
        background-color: #FFDCA3;
    }
    .zfyz .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .zfyz h2 {
        text-align: center;
    }
    .zfyz h3{
        text-align: center;
    }
   
    .zfyz /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
    .zfyz h4 {
        text-indent: 16px;
    }
    .zfyz /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }
    .zfyz[data-v-c2ee7228] /deep/ .van-field__label {
        flex: none;
        box-sizing: border-box;
        width: 6.8em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        
        word-wrap: break-word;
    }
    .zfyz .div1 {
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 10px 16px;
        overflow: hidden;
        color: #323233;
        font-size: 14px;
        line-height: 24px;
        background-color: #fff;
        span {
            flex: none;
            box-sizing: border-box;
            width: 6.2em;
            margin-right: 30px;
            color: #646566;
            text-align: left;
            word-wrap: break-word;
        }
        .div2 {
            position: relative;
            color: #969799;
            text-align: right;
            vertical-align: middle;
            word-wrap: break-word;
            select {
                width: 100%;
            }
        }
    }
</style>
